export default "__VITE_ASSET__dUF0CmbT__"